/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import GenericElement from '../Utils/GenericElement';
import loadJsonData from '../Utils/loadJsonData';
import LocalStorage from 'Helpers/MFXLocalStorage';
import URLS from '../Utils/URLs.API';
import Loading from 'Components/Lib/Elements/Loading';
import { toDateFormat } from '../../../Helpers/dateHelper';
import InputElement from '../Elements/InputElement';
import loadJsonPost from '../Utils/jsonPost';
import Editbutton from '../Elements/Editbutton';
import { useSearchParams } from 'react-router-dom';
import { useSettings } from 'Helpers/Stores/SettingsProvider';

export function ExpenseReportPositionsView(props: any) {
    const [data, setData] = useState(null as any);
    const [loading, setLoading] = useState(true);
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
    const [toDate, setToDate] = useState(endOfMonth(new Date()));
    const [km, setKm] = useState(0);
    const [kmPrice, setKmPrice] = useState(0);
    const [dayMoney, setDayMoney] = useState(0);
    const [pocketExpense, setPocketExpense] = useState(0);
    const [selected, setSelected] = useState(useSearchParams()[0].get('expensereport'));
    const { systemSettings } = useSettings();
    console.log(systemSettings);
    useEffect(() => {
        loadData();
    }, [fromDate, toDate]);

    function addParamToUrl(index) {
        var params = window.location.href.split('?')[1];
        if (params) {
            var newParams = params.split('&').filter(p => !p.includes('expensereport'));
            newParams.push('expensereport=' + index);
            params = newParams.join('&');
        } else {
            params = 'expensereport=' + index;
        }
        var newurl = window.location.href.split('?')[0] + (params ? '?' + params : '');
        if (window.location.href !== newurl) window.history.replaceState({ path: newurl }, '', encodeURI(newurl));
    }

    function loadData() {
        setLoading(true);
        let start = toDateFormat(fromDate);
        let end = toDateFormat(toDate);
        loadJsonData('/' + LocalStorage.getConnectionKey() + URLS.GetTravelExpenses + '?Data.Filter.BeginDate=' + start + '&Data.Filter.EndDate=' + end).then((data: any) => {
            if (data.Meta.Success && data.Data && data.Data.TravelExpenseData.length > 0) {
                setData(data.Data.TravelExpenseData);
                addParamToUrl(data.Data.TravelExpenseData[0].Index);
                setSelected(data.Data.TravelExpenseData[0].Index);

                var kmVal = 0;
                var kmPriceVal = 0;
                var dayMoneyVal = 0;
                var pocketExpenseVal = 0;

                data.Data.TravelExpenseData.forEach(expense => {
                    if (expense.DayMoney) console.log(expense.DayMoney);
                    kmVal += expense.Kilometers >= 0 ? expense.Kilometers : 0;
                    kmPriceVal += expense.KilometerCostsTotal >= 0 ? expense.KilometerCostsTotal : 0;
                    dayMoneyVal += expense.DayMoney >= 0 ? expense.DayMoney : 0;
                    pocketExpenseVal += expense.PocketExpenses >= 0 ? expense.PocketExpenses : 0;
                });

                setKm(kmVal);
                setKmPrice(kmPriceVal);
                setDayMoney(dayMoneyVal);
                setPocketExpense(pocketExpenseVal);
            }
            setLoading(false);
        });
    }

    function endOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0, 12, 0, 0);
    }

    function startOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth(), 1, 12, 0, 0);
    }

    function onChange(id, key, newValue) {
        if ((key === 'Departure' && data[id].Arrival && new Date(newValue) > new Date(data[id].Arrival)) || (key === 'Arrival' && data[id].Departure && new Date(data[id].Departure) > new Date(newValue))) {
            console.log('Arrival > Departure');
            return;
        }
        data[id][key] = newValue;
        if (key === 'Date') {
            if (data[id].Departure) {
                var newDeparture = new Date(newValue);
                data[id].Departure = new Date(data[id].Departure);
                newDeparture.setHours(data[id].Departure.getHours(), data[id].Departure.getMinutes(), data[id].Departure.getSeconds());
            }
            if (data[id].Arrival) {
                var newArrival = new Date(newValue);
                data[id].Arrival = new Date(data[id].Arrival);
                newArrival.setHours(data[id].Arrival.getHours(), data[id].Arrival.getMinutes(), data[id].Arrival.getSeconds());
            }
        } else if (key === 'Kilometers') {
            data[id].KilometerCostsTotal = data[id].Kilometers * data[id].KilometerCostsFee;
        }
        setData(data.map(o => ({ ...o })));
    }
    console.log(systemSettings);
    function save(e) {
        setLoading(true);
        e.preventDefault();
        var body = {
            Data: {
                TravelExpenseData: data,
            },
        };
        loadJsonPost('/' + LocalStorage.getConnectionKey() + URLS.UpdateTravelExpenses, body).then((data: any) => {
            loadData();
        });
    }

    return (
        <div className="mfx-view-timerecording">
            <div className="mfx-action-buttons">
                <Editbutton saveChangeHandler={e => save(e)} saveId="button-save-expense-report" />
            </div>
            <div className="mfx-table-container time-recording-positions">
                <div className="mfx-from-to-date-wrapper">
                    <InputElement uniqueIndex="from" id="date-for" customerData={fromDate} designData={{ Type: 'date', Defaultvalue: fromDate, Key: 'ChangeDate', Label: 1586 }} disableMode={false} onChangeHandler={e => setFromDate(new Date(e.newValue))}></InputElement>
                    <InputElement uniqueIndex="until" customerData={toDate} designData={{ Type: 'date', Defaultvalue: toDate, Key: 'ChangeDate', Label: 1587 }} disableMode={false} onChangeHandler={e => setToDate(new Date(e.newValue))}></InputElement>
                </div>
                {loading && <Loading />}
                {data && !loading && (
                    <>
                        <div className="mfx-table-container">
                            <table className="mfx-table" style={{ width: 'unset', tableLayout: 'auto' }}>
                                <tr>
                                    {props.designer?.TableElements &&
                                        props.designer?.TableElements[0] &&
                                        Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                            return <th style={{ color: designer[1].ReadOnly ? 'var(--gray)' : 'var(--fontColor)' }}>{window.Dictionary.getTranslation(designer[1].Label)}</th>;
                                        })}
                                </tr>
                                {data.map((d, id) => {
                                    return (
                                        <tr
                                            id={'tr-table-expense-report-' + id}
                                            onClick={e => {
                                                addParamToUrl(d.Index);
                                                setSelected(d.Index);
                                            }}
                                            style={{ backgroundColor: d.Index === selected ? 'var(--base)' : '' }}>
                                            {props.designer?.TableElements &&
                                                props.designer?.TableElements[0] &&
                                                Object.entries(props.designer.TableElements[0]).map((designer: any, idx) => {
                                                    var value = d[designer[1].Key];
                                                    return (
                                                        <td>
                                                            <GenericElement fitContent={true} customData={value} designData={{ ...designer[1] }} key={id + idx} index={idx} onChangeGenericElement={e => onChange(id, e.designData.Key, e.newValue)} />
                                                        </td>
                                                    );
                                                })}
                                        </tr>
                                    );
                                })}
                            </table>
                        </div>
                        <div className="expense-report-sums">
                            <div className="expense-report-sum">
                                <label>{window.Dictionary.getTranslation(6085)}</label>
                                <input disabled type="number" value={dayMoney.toFixed(2)}></input>
                                <span>{systemSettings?.Region.Currency}</span>
                            </div>
                            <div className="expense-report-sum">
                                <label>{window.Dictionary.getTranslation(6086)}</label>
                                <input disabled type="number" value={pocketExpense.toFixed(2)}></input>
                                <span>{systemSettings?.Region.Currency}</span>
                            </div>
                            <div className="expense-report-sum">
                                <label>{window.Dictionary.getTranslation(6088)}</label>
                                <input disabled type="number" value={km.toFixed(2)}></input>
                                <input disabled type="number" value={kmPrice.toFixed(2)} style={{ marginLeft: '20px' }}></input>
                                <span>{systemSettings?.Region.Currency}</span>
                            </div>
                            <div className="expense-report-sum">
                                <label>{window.Dictionary.getTranslation(6089)}</label>
                                <div className="complete-sum"></div>
                                <input disabled type="number" value={(dayMoney + pocketExpense + kmPrice).toFixed(2)}></input>
                                <span>{systemSettings?.Region.Currency}</span>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
